import * as React from 'react'
import { ReactElement } from 'react'
import {
    Button,
    Field,
    makeStyles,
    mergeClasses,
    TeachingPopover,
    TeachingPopoverBody,
    TeachingPopoverCarousel,
    TeachingPopoverCarouselCard,
    TeachingPopoverCarouselFooter,
    TeachingPopoverCarouselNav,
    TeachingPopoverCarouselNavButton,
    TeachingPopoverSurface,
    TeachingPopoverTitle,
    TeachingPopoverTrigger,
    tokens,
} from '@fluentui/react-components'
import {
    ArrowClockwiseFilled,
    ArrowClockwiseRegular,
    BookOpenFilled,
    BookOpenRegular,
    bundleIcon,
    createFluentIcon,
    HeadsetFilled,
    HeadsetRegular,
} from '@fluentui/react-icons'
import { Link } from '@fluentui/react'
import { useTranslation } from 'react-i18next'

const ArrowClockwiseIcon = bundleIcon(ArrowClockwiseFilled, ArrowClockwiseRegular)
const BookIcon = bundleIcon(BookOpenFilled, BookOpenRegular)
const HeadsetIcon = bundleIcon(HeadsetFilled, HeadsetRegular)
const TeamViewer = createFluentIcon('TeamViewer', '1em', ['./icons/teamviewer.svg'])

const useStyles = makeStyles({
    popoverButton: {
        marginBottom: tokens.spacingVerticalXS,
    },
    container: {
        display: 'grid',
        gridTemplateColumns: `1fr`,
    },
    half: {
        width: '50%',
    },
    field: {
        gridTemplateColumns: `40% 1fr`,
        paddingBottom: tokens.spacingVerticalXXS,
    },
})

function Contact(): ReactElement {
    const styles = useStyles()

    return (
        <div className={styles.container}>
            <Field label="Telefoon" orientation={'horizontal'} className={styles.field}>
                <Link href="tel:0262062199" target="_blank">
                    026 - 206 21 99
                </Link>
            </Field>
            <Field label="E-mail" orientation={'horizontal'} className={styles.field}>
                <Link href="mailto:support@hammock.nl" target="_blank">
                    support@hammock.nl
                </Link>
            </Field>
            <Field label="Openingstijden" orientation={'horizontal'} className={styles.field}>
                Maandag t/m Vrijdag:
                <br />
                8:30 - 17:30
            </Field>
        </div>
    )
}

function Tools(): ReactElement {
    const styles = useStyles()

    return (
        <div className={mergeClasses(styles.container, styles.half)}>
            <Button icon={<BookIcon />} appearance={'subtle'}>
                Handleiding
            </Button>
            <Button icon={<TeamViewer />} appearance={'subtle'}>
                Teamviewer
            </Button>
            <Button icon={<ArrowClockwiseIcon />} appearance={'subtle'}>
                Herstarten
            </Button>
        </div>
    )
}

function Diagnostics(): ReactElement {
    const styles = useStyles()

    return (
        <div className={styles.container}>
            <Field label="Telefoon" orientation={'horizontal'} className={styles.field}>
                <Link href="tel:0262062199" target="_blank">
                    026 - 206 21 99
                </Link>
            </Field>
            <Field label="E-mail" orientation={'horizontal'} className={styles.field}>
                <Link href="mailto:support@hammock.nl" target="_blank">
                    support@hammock.nl
                </Link>
            </Field>
            <Field label="Openingstijden" orientation={'horizontal'} className={styles.field}>
                Maandag t/m Vrijdag:
                <br />
                8:30 - 17:30
            </Field>
        </div>
    )
}

export default function SupportV9(): ReactElement {
    const styles = useStyles()
    const { t: translate } = useTranslation()

    return (
        <>
            <TeachingPopover withArrow size={'large'}>
                <TeachingPopoverTrigger>
                    <Button
                        id="support-v9"
                        icon={<HeadsetIcon />}
                        content={'Ondersteuning en diagnostiek'}
                        appearance={'subtle'}
                        className={styles.popoverButton}
                    >
                        {translate('support.label')}
                    </Button>
                </TeachingPopoverTrigger>
                <TeachingPopoverSurface>
                    <TeachingPopoverCarousel defaultValue={'support-0'}>
                        <TeachingPopoverCarouselCard value="support-0">
                            <TeachingPopoverBody>
                                <TeachingPopoverTitle>{'Contactinformatie'}</TeachingPopoverTitle>
                                <Contact />
                            </TeachingPopoverBody>
                        </TeachingPopoverCarouselCard>
                        <TeachingPopoverCarouselCard value="support-1">
                            <TeachingPopoverBody>
                                <TeachingPopoverTitle>{'Hulpmiddelen'}</TeachingPopoverTitle>
                                <Tools />
                            </TeachingPopoverBody>
                        </TeachingPopoverCarouselCard>
                        <TeachingPopoverCarouselCard value="support-2">
                            <TeachingPopoverBody>
                                <TeachingPopoverTitle>{'Hulpmiddelen'}</TeachingPopoverTitle>
                                <Diagnostics />
                            </TeachingPopoverBody>
                        </TeachingPopoverCarouselCard>

                        <TeachingPopoverCarouselFooter
                            next={'Volgende'}
                            previous={'Vorige'}
                            initialStepText={'Sluiten'}
                            finalStepText={'Sluiten'}
                        >
                            <TeachingPopoverCarouselNav>
                                {() => <TeachingPopoverCarouselNavButton />}
                            </TeachingPopoverCarouselNav>
                        </TeachingPopoverCarouselFooter>
                    </TeachingPopoverCarousel>
                </TeachingPopoverSurface>
            </TeachingPopover>
        </>
    )
}
